/* eslint-disable react-hooks/exhaustive-deps */
import {
  mdiArrowBottomLeft,
  mdiArrowTopRight,
  mdiFilterVariant,
  mdiTrayArrowDown,
} from "@mdi/js";
import Icon from "@mdi/react";
import debounce from "lodash.debounce";
import moment from "moment";
import { FunctionComponent, useCallback, useEffect, useState } from "react";
import LoadingWidget from "../../../../context_providers/modal/loader";
import {
  useToast,
  ToastType,
} from "../../../../context_providers/toast/toast_ctx";
import { parse } from "papaparse";
import SearchFieldWidget from "../../../../ui/new_components/search_field";
import {
  payment_status,
  PaymentAttachmentModel,
  PaymentModeOptions,
  PaymentRequestModel,
  po_payments_req_status,
  PRType,
} from "../../model/payment_request_model";
import DrawerModal, {
  DrawerModalLoaction,
} from "../../../../ui/new_components/common/drawer_modal";
import ActionHistoryAdvance from "../components/payment_request_advance_history_logs";
import {
  defaultFilter,
  PaymentFilterModule,
  sanitizeFilter,
} from "../payment_requests_list";
import {
  getPaymentList,
  postImportPaymentList,
} from "../../purchase_order_create/service/purchase_order_repository";
import FilterDropDown from "../../../../ui/new_components/common/filter_drop_down";
import ModalDialog from "../../../../ui/new_components/common/modal";
import FileDropZone from "../../../../ui/new_components/common/file_drop_zone";
import DrawerWidget from "../../../../context_providers/modal/drawer_widget";
import {
  ModalAlignment,
  ModalType,
} from "../../../../context_providers/modal/modal_context";
import AttachmentBar from "../components/attachmentBar";
import { toQueryString } from "../../../../service/api_client";
import { CreatorMultiFilter } from "../../../../ui/new_components/entity_selects/EntityMultiFilters";
import {
  ResponsiveListShell,
  FilterSheet,
  DateRangeFilter,
  EmptyState,
  TextFilterInput,
} from "../../../../ui/new_components/common/responsive";
import PaymentRequestTable from "../components/payment_request_table";

interface PaymentRequestApprovalListProps {}

const PaymentRequestApprovalListForAdvanceAndInvoice: FunctionComponent<
  PaymentRequestApprovalListProps
> = () => {
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [showImport, setShowImport] = useState(false);
  const [count] = useState(50);
  const tempFilter = localStorage.getItem("pr_approval_filter");
  const [total, setTotal] = useState(0);
  const [showHistoryAdvance, setShowHistoryAdvance] = useState<any>();
  const [showHistoryAdvance1, setShowHistoryAdvance1] = useState<any>();
  const [filter, setFilter] = useState<PaymentFilterModule>(
    tempFilter ? JSON.parse(tempFilter) : defaultFilter,
  );
  const [showAttachment, setShowAttachment] = useState<PaymentRequestModel>();
  const [attachmentKey, setAttachmentKey] = useState(Math.random() * 10000);
  const [search, setSearch] = useState("");
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [paymentRequest, setPaymentRequest] = useState<PaymentRequestModel[]>(
    [],
  );
  const [errorMessages, setErrorMessages] = useState<string | null>(null);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showRejectedModal, setShowRejectedModal] = useState(false);
  const [failed, setFailed] = useState<string[]>([]);
  const [showFilter, setShowFilter] = useState(
    () => typeof window !== "undefined" && window.innerWidth >= 768,
  );

  useEffect(() => {
    const now = new Date();
    let from = new Date(new Date(now).setHours(0, 0, 0, 0));
    from = new Date(from.setDate(1));
    let to = new Date(new Date(now).setHours(23, 59, 59, 999));
    to = new Date(to.setMonth(now.getMonth() + 1));
    to = new Date(to.setDate(0));
    setFromDate(from);
    setToDate(to);
  }, []);

  const onSelectAttchment = (d: PaymentAttachmentModel) => {
    window.open(d.url, "_blank");
  };

  const handleDownloadTemplate = () => {
    const headers = [
      "PR_ID",
      "PO",
      "UTR",
      "Swift",
      "Payment_Amount",
      "Payment_Status",
      "PR_Status",
      "Payment_Date",
      "Amount_Paid",
      "TDS_Amount",
      "TDS_Percent",
      "Paid_Remarks",
    ];

    const csvContent = [headers]
      .map((row) => row.map((cell) => `"${cell}"`).join(","))
      .join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "payment_template.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const getPRListData = async () => {
    try {
      const a = document.createElement("a");
      a.target = "_blank";

      a.href = `${
        process.env.REACT_APP_BACKEND_BASE_URL
      }/api/v3/erp/purchase-order/advance_payment_request/export${toQueryString(
        {
          query: JSON.stringify({
            ...filter,
          }),
        },
      )}`;

      // Delay the trigger to allow UI updates (if necessary)
      setTimeout(() => {
        setLoading(false);
        showToast({ type: ToastType.success, text: "Download started!" });
        a.click(); // Trigger the download
      }, 1000);
    } catch (error) {
      setLoading(false); // Make sure loading is set to false in case of an error
      showToast({ type: ToastType.error, text: "Failed to start download." });
    }
  };

  // Function to fetch data based on the request type
  const fetchData = async (prop: {
    search?: string;
    page: number;
    count: number;
    all?: boolean;
    fromDate?: Date;
    toDate?: Date;
    filterData?: {
      poNo?: string;
      pr_id?: string;
      pi_no_Or_Inv_no?: string;
      created_by_name?: string[];
      emp_names?: string;
      type?: string[];
      payment_mode?: string[];
      due_date?: Date;
      created_date?: Date;
      pr_status?: string[];
      payment_status?: string[];
    };
  }) => {
    setLoading(true); // Start loading state
    try {
      const res = await getPaymentList(prop);

      if (res.success) {
        setPaymentRequest(res.data.data);
        if (res.data.metadata) {
          setTotal(res.data.metadata.total);
        }
      } else {
        showToast({ type: ToastType.error, text: res.error });
      }
    } catch (error: any) {
      showToast({
        type: ToastType.error,
        text: error?.message || error.toString(),
      });
    }

    setLoading(false); // End loading state
  };

  // Debounced handler
  const debouncedHandler = useCallback(
    debounce(
      (prop: {
        search?: string;
        page: number;
        count: number;
        all?: boolean;
        fromDate?: Date;
        toDate?: Date;
        filterData?: {
          poNo?: string;
          pr_id?: string;
          pi_no_Or_Inv_no?: string;
          created_by_name?: string[];
          emp_names?: string;
          type?: string[];
          payment_mode?: string[];
          due_date?: Date;
          created_date?: Date;
          pr_status?: string[];
          payment_status?: string[];
        };
      }) => {
        // Simply fetch data, the paymentRequestType logic is handled inside fetchData
        if (prop) {
          fetchData(prop);
        } else {
          setPaymentRequest([]);
        }
      },
      100, // Debounce delay (100ms)
    ),
    [], // Empty dependency array, meaning it will only be created once
  );

  useEffect(() => {
    const cleanedFilterData = sanitizeFilter(filter.filterData);

    debouncedHandler({
      ...filter,
      fromDate,
      toDate,
      filterData: cleanedFilterData,
    });

    localStorage.setItem(
      "pr_approval_filter",
      JSON.stringify({
        ...filter,
        filterData: cleanedFilterData,
      }),
    );
  }, [page, count, search, fromDate, toDate, filter]);

  const onImport = async (data: PaymentRequestModel[]) => {
    try {
      setLoading(true);
      const res = await postImportPaymentList(data);
      if (res.success) {
        if (res.valid?.length === 0)
          showToast({
            type: ToastType.warning,
            text: `No rows effected/ updated:` + res.valid.length,
          });
        if (res.failed?.length > 0) {
          setFailed(res.failed);
          setShowRejectedModal(true);
        }
        if (res.invalid?.length > 0) {
          const errorMessages = Object.entries(res.invalid)
            .map(([key, value]) => {
              if (typeof value === "object") {
                return `${key}: ${JSON.stringify(value)}`;
              }
              return `${key}: ${value}`;
            })
            .join("\n"); // Join with new lines for better readability
          setErrorMessages(errorMessages);
          setShowErrorModal(true);
        }
        if (
          res.failed?.length === 0 &&
          res.invalid?.length === 0 &&
          res.valid?.length > 0
        ) {
          showToast({
            type: ToastType.success,
            text: "Import successful!",
          });
          await getPaymentList(filter);
        }
      } else {
        if (res.date_errors?.length) {
          const header =
            `Import rejected — ${res.date_errors.length} PR(s) have an invalid ` +
            `Payment_Date (required format: DD-MM-YYYY). Fix these and re-upload:\n\n`;
          const list = res.date_errors
            .map((e: any, i: number) => `${i + 1}. ${e.pr_id} → "${e.value}"`)
            .join("\n");
          setErrorMessages(header + list);
          setShowErrorModal(true);
        } else {
          // Handle error case
          showToast({
            type: ToastType.error,
            text: res.error || "An unexpected error occurred.",
          });
        }
      }
    } catch (error) {
      showToast({
        type: ToastType.error,
        text: "Failed to import data.",
      });
    } finally {
      await getPaymentList(filter);
      setLoading(false);
    }
  };

  const clearLocalStore = () => {
    // Remove from localStorage
    localStorage.removeItem("pr_approval_filter");

    // Reset filter state
    const defaultFilterObj = defaultFilter;
    setFilter(defaultFilterObj);

    // Trigger UI updates and fetch
    debouncedHandler(defaultFilterObj);
    fetchData(defaultFilterObj);
  };
  return (
    <>
      {showRejectedModal && (
        <ModalDialog
          id="payment_request_approvals_list_rejected_modal"
          show={showRejectedModal}
          title="Rejected Payments"
          onClose={() => setShowRejectedModal(false)}
        >
          <div className="p-4">
            <pre className="bg-gray-100 p-2 rounded text-red-600 whitespace-pre-wrap">
              <div className="modal-content">
                <h2>Rejected Payments</h2>
                <ul>
                  {failed.map((id: any, index: any) => (
                    <li key={index}>{id}</li>
                  ))}
                </ul>
              </div>
            </pre>
          </div>
        </ModalDialog>
      )}
      {showErrorModal && (
        <ModalDialog
          id="payment_request_approvals_list_import_errors_modal"
          show={showErrorModal}
          title="Import Errors"
          onClose={() => setShowErrorModal(false)}
        >
          <div className="p-4">
            <pre className="bg-gray-100 p-2 rounded text-red-600 whitespace-pre-wrap">
              {errorMessages}
            </pre>
          </div>
        </ModalDialog>
      )}

      {showImport && (
        <ModalDialog
          id="payment_request_approvals_list_import_modal"
          show={showImport}
          onClose={() => setShowImport(false)}
          title="Import Payment Request"
        >
          <div className="text-xs w-full sm:w-96">
            <h2 className="font-semibold">Please note :</h2>
            <p>sheet should have header as</p>
            <p className="font-semibold text-purple-500">
              [PR_ID*, PO*, UTR*, Swift, Payment_Amount*, Payment_Status*,
              PR_Status*, Payment_Date*, Amount_Paid*, TDS_Amount, TDS_Percent,
              Paid_Remarks, ]
            </p>
            <p>In the first row of csv.</p>
            <p className="mt-2">Validation Rules:</p>
            <ul className="list-disc list-inside ml-2">
              <li>
                <code>Payment_Status</code> must be <strong>Pending</strong>
              </li>
              <li>
                <code>PR_Status</code> must be <strong>Approved</strong>
              </li>
              <li>
                <code>Amount_Paid + TDS_Amount</code> must be equal to{" "}
                <code>Payment_Amount</code>
              </li>
              <li>
                <code>Payment_Date</code> must be in <strong>DD-MM-YYYY</strong>{" "}
                format (e.g. <code>07-06-2026</code>)
              </li>
            </ul>
          </div>
          <div className="h-72 sm:h-96 w-full sm:w-96 mt-5">
            <FileDropZone
              accept=".csv"
              onDrop={(files) => {
                parse<any>(files[0], {
                  header: true,
                  skipEmptyLines: true,
                  transformHeader: (h) => h.replace(/^﻿/, "").trim(),
                  complete: (data) => {
                    const res = data.data;
                    if (res.length === 0) {
                      showToast({
                        type: ToastType.info,
                        text: "No record found !",
                      });
                      return;
                    }
                    const keys = Object.keys(res[0]);
                    if (
                      keys.indexOf("PR_ID") === -1 ||
                      keys.indexOf("PO") === -1
                    ) {
                      showToast({
                        type: ToastType.error,
                        text: "Required fields are PR_ID, PO !",
                      });
                      return;
                    }
                    const filteredData: any[] = [];
                    for (let index = 0; index < res.length; index++) {
                      const {
                        PR_ID,
                        PO,
                        UTR,
                        Swift,
                        Payment_Amount,
                        Payment_Status,
                        PR_Status,
                        Payment_Date,
                        Amount_Paid,
                        TDS_Amount,
                        TDS_Percent,
                        Paid_Remarks,
                      } = res[index];
                      if (
                        !PR_ID ||
                        !PO ||
                        !UTR ||
                        !Payment_Date ||
                        !Amount_Paid ||
                        !PR_Status
                      ) {
                        showToast({
                          type: ToastType.error,
                          text: "Missing required data !",
                        });

                        return;
                      }
                      let tempAmount_Paid = Number(
                        Amount_Paid.replace(/,/g, ""),
                      );
                      let tempPayment_Amount = Number(
                        Payment_Amount.replace(/,/g, ""),
                      );
                      let tempTDS_Amount = Number(TDS_Amount.replace(/,/g, ""));

                      filteredData.push({
                        id: PR_ID,
                        po_no: PO,
                        utr: UTR,
                        swift: Swift,
                        payment_amount: tempPayment_Amount,
                        payment_status: Payment_Status,
                        pr_status: PR_Status,
                        payment_date: Payment_Date,
                        amount_paid: tempAmount_Paid,
                        tds_amount: tempTDS_Amount,
                        tds_percent: TDS_Percent,
                        paid_remarks: Paid_Remarks,
                      });
                    }

                    setShowImport(false);
                    onImport(filteredData);
                  },
                });
              }}
            />
          </div>
        </ModalDialog>
      )}

      {showHistoryAdvance && (
        <DrawerModal
          id="payment_request_approvals_list_history_drawer"
          location={DrawerModalLoaction.right}
          show={showHistoryAdvance !== undefined}
          onClose={() => setShowHistoryAdvance(undefined)}
          title="History"
        >
          <ActionHistoryAdvance
            pr_id={showHistoryAdvance}
            data={showHistoryAdvance1}
          />
        </DrawerModal>
      )}

      {showAttachment && (
        <DrawerWidget
          id="payment_request_approvals_list_attachment_drawer"
          data={{
            id: 1,
            title: "Attchments",
            type: ModalType.drawer,
            alignment: ModalAlignment.right,
            container: (
              <AttachmentBar
                key={attachmentKey}
                attachments={showAttachment.attachments}
                // onSubmit={uploadFile}
                // onDelete={deleteFile}
                onSelect={onSelectAttchment}
              />
            ),
          }}
          onClose={function (): void {
            setShowAttachment(undefined);
          }}
        ></DrawerWidget>
      )}

      <ResponsiveListShell
        title="PO Payment Requests Approval"
        count={total}
        onRefresh={() =>
          debouncedHandler({
            ...filter,
            fromDate,
            toDate,
            filterData: sanitizeFilter(filter.filterData),
          })
        }
        search={
          <div id="payment_request_approvals_list_search">
            <SearchFieldWidget
              placeholder="Search PO No."
              defaulValue={filter.filterData?.poNo}
              onClear={() => {
                setFilter({
                  ...filter,
                  filterData: {
                    ...filter.filterData,
                    poNo: undefined,
                  },
                });
                setPage(1);
              }}
              onSubmit={(val) => {
                setFilter({
                  ...filter,
                  filterData: {
                    ...filter.filterData,
                    poNo: val,
                  },
                });
                setPage(1);
              }}
            />
          </div>
        }
        actions={
          <>
            <button
              id="payment_request_approvals_list_clear_filter_btn"
              className="flex gap-1 items-center cursor-pointer rounded p-1 bg-myPrimaryColor hover:scale-105 duration-200 text-xs text-white transform"
              onClick={() => clearLocalStore()}
            >
              Clear Filter
            </button>
            <label
              id="payment_request_approvals_list_download_template_btn"
              title="Download template"
              onClick={handleDownloadTemplate}
              className="flex gap-1 items-center cursor-pointer rounded p-1 bg-myPrimaryColor hover:scale-105 duration-200 text-white transform text-xs"
            >
              <Icon path={mdiTrayArrowDown} className="h-4 w-4"></Icon>
              Template
            </label>
            <button
              id="payment_request_approvals_list_import_btn"
              onClick={() => {
                setShowImport(true);
              }}
              className="flex gap-1 items-center cursor-pointer rounded p-1 bg-myPrimaryColor hover:scale-105 duration-200 text-white transform text-xs"
            >
              <Icon path={mdiArrowBottomLeft} className="h-4 w-4"></Icon>
              Import
            </button>
            <button
              id="payment_request_approvals_list_export_btn"
              onClick={() => {
                getPRListData();
              }}
              className="flex gap-1 items-center cursor-pointer rounded p-1 bg-myPrimaryColor hover:scale-105 duration-200 text-white transform text-xs"
            >
              <Icon path={mdiArrowTopRight} className="h-4 w-4"></Icon>
              Export PR
            </button>
          </>
        }
        filterToggle={
          <div className="flex gap-2 items-center">
            <h6 className="font-normal text-xs">Filters</h6>
            <div
              id="payment_request_approvals_list_filter_toggle_btn"
              onClick={() => setShowFilter((v) => !v)}
              className="flex items-center justify-center bg-gray-200 p-1 rounded-full hover:bg-gray-800 hover:text-white cursor-pointer"
            >
              <Icon path={mdiFilterVariant} className="w-4 h-4" />
            </div>
          </div>
        }
      >
        <FilterSheet
          show={showFilter}
          onClose={() => setShowFilter(false)}
          onApply={() => setShowFilter(false)}
          onReset={() => clearLocalStore()}
          gridClassName="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-3 gap-y-2 items-start"
        >
          <div id="payment_request_approvals_list_date_filter">
            <label className="text-xs font-semibold">Date</label>
            <DateRangeFilter
              compact
              showChips={false}
              fromDate={
                filter.filterData?.created_date
                  ? moment(filter.filterData?.created_date).format("YYYY-MM-DD")
                  : undefined
              }
              toDate={
                filter.filterData?.due_date
                  ? moment(filter.filterData?.due_date).format("YYYY-MM-DD")
                  : undefined
              }
              onFromChange={(v) =>
                setFilter({
                  ...filter,
                  filterData: {
                    ...filter.filterData,
                    created_date: v
                      ? new Date(new Date(v).setHours(0, 0, 0, 0))
                      : undefined,
                  },
                })
              }
              onToChange={(v) =>
                setFilter({
                  ...filter,
                  filterData: {
                    ...filter.filterData,
                    due_date: v
                      ? new Date(new Date(v).setHours(0, 0, 0, 0))
                      : undefined,
                  },
                })
              }
            />
          </div>
          <div id="payment_request_approvals_list_pr_id_filter">
            <label className="text-xs font-semibold">PR ID</label>
            <TextFilterInput
              id="payment_request_approvals_list_pr_id_filter"
              placeholder="Search PR ID"
              value={filter.filterData?.pr_id}
              onChange={(pr_id) => {
                setFilter((old) => ({
                  ...old,
                  filterData: { ...old.filterData, pr_id },
                }));
                setPage(1);
              }}
            />
          </div>
          <div id="payment_request_approvals_list_pi_invoice_no_filter">
            <label className="text-xs font-semibold">PI/Invoice No.</label>
            <TextFilterInput
              id="payment_request_approvals_list_pi_invoice_no_filter"
              placeholder="Search PI/Invoice No"
              value={filter.filterData?.pi_no_Or_Inv_no}
              onChange={(pi_no_Or_Inv_no) => {
                setFilter((old) => ({
                  ...old,
                  filterData: { ...old.filterData, pi_no_Or_Inv_no },
                }));
                setPage(1);
              }}
            />
          </div>
          <div id="payment_request_approvals_list_created_by_filter">
            <label className="text-xs font-semibold">Created By</label>
            <CreatorMultiFilter
              source="payment_request"
              values={filter.filterData?.created_by_name}
              onChange={(created_by_name) => {
                setFilter((old) => ({
                  ...old,
                  filterData: {
                    ...old.filterData,
                    created_by_name,
                    emp_names: undefined,
                  },
                }));
                setPage(1);
              }}
            />
          </div>
          <div>
            <label className="text-xs font-semibold">Payment Status</label>
            <FilterDropDown
              id="payment_request_approvals_list_payment_status_filter"
              placeholder="Payment Status"
              onClearAll={() =>
                setFilter({
                  ...filter,
                  filterData: {
                    ...filter.filterData,
                    payment_status: undefined,
                  },
                })
              }
              onDelete={(type) => {
                setFilter({
                  ...filter,
                  filterData: {
                    ...filter.filterData,
                    payment_status: filter.filterData?.payment_status?.filter(
                      (f: any) => f !== type,
                    ),
                  },
                });
              }}
              onSelect={(type) => {
                setFilter((old) => ({
                  ...old,
                  filterData: {
                    ...old.filterData,
                    payment_status: [
                      ...(old.filterData?.payment_status ?? []),
                      type,
                    ],
                  },
                }));
              }}
              selectedOptions={filter.filterData?.payment_status ?? []}
              options={Object.values(payment_status).map((t) => ({
                label: t,
                value: t,
              }))}
            />
          </div>
          <div>
            <label className="text-xs font-semibold">PR Status</label>
            <FilterDropDown
              id="payment_request_approvals_list_pr_status_filter"
              placeholder="PR Status"
              onClearAll={() =>
                setFilter({
                  ...filter,
                  filterData: {
                    ...filter.filterData,
                    pr_status: undefined,
                  },
                })
              }
              onDelete={(type) => {
                setFilter({
                  ...filter,
                  filterData: {
                    ...filter.filterData,
                    pr_status: filter.filterData?.pr_status?.filter(
                      (f: any) => f !== type,
                    ),
                  },
                });
              }}
              onSelect={(type) => {
                setFilter((old) => ({
                  ...old,
                  filterData: {
                    ...old.filterData,
                    pr_status: [...(old.filterData?.pr_status ?? []), type],
                  },
                }));
              }}
              selectedOptions={filter.filterData?.pr_status ?? []}
              options={Object.values(po_payments_req_status).map((t) => ({
                label: t,
                value: t,
              }))}
            />
          </div>
          <div>
            <label className="text-xs font-semibold">Type</label>
            <FilterDropDown
              id="payment_request_approvals_list_type_filter"
              placeholder="Type"
              onClearAll={() =>
                setFilter({
                  ...filter,
                  filterData: {
                    ...filter.filterData,
                    type: undefined,
                  },
                })
              }
              onDelete={(type) => {
                setFilter({
                  ...filter,
                  filterData: {
                    ...filter.filterData,
                    type: filter.filterData?.type?.filter(
                      (f: any) => f !== type,
                    ),
                  },
                });
              }}
              onSelect={(type) => {
                setFilter((old) => ({
                  ...old,
                  filterData: {
                    ...old.filterData,
                    type: [...(old.filterData?.type ?? []), type],
                  },
                }));
              }}
              selectedOptions={filter.filterData?.type ?? []}
              options={Object.values(PRType).map((t) => ({
                label: t,
                value: t,
              }))}
            />
          </div>
          <div>
            <label className="text-xs font-semibold">Payment Mode</label>
            <FilterDropDown
              id="payment_request_approvals_list_payment_mode_filter"
              placeholder="select payment"
              onClearAll={() =>
                setFilter({
                  ...filter,
                  filterData: {
                    ...filter.filterData,
                    payment_mode: undefined,
                  },
                })
              }
              onDelete={(type) => {
                setFilter({
                  ...filter,
                  filterData: {
                    ...filter.filterData,
                    payment_mode: filter.filterData?.payment_mode?.filter(
                      (f: any) => f !== type,
                    ),
                  },
                });
              }}
              onSelect={(type) => {
                setFilter((old) => ({
                  ...old,
                  filterData: {
                    ...old.filterData,
                    payment_mode: [
                      ...(old.filterData?.payment_mode ?? []),
                      type,
                    ],
                  },
                }));
              }}
              selectedOptions={filter.filterData?.payment_mode ?? []}
              options={Object.values(PaymentModeOptions).map((t) => ({
                label: t,
                value: t,
              }))}
            />
          </div>
        </FilterSheet>

        {paymentRequest.length === 0 && !loading ? (
          <EmptyState
            title="No Payment Requests found!"
            message="Try adjusting your search or filters."
            imageSrc="/images/nodata.png"
          />
        ) : (
          <div id="payment_request_approvals_list_table">
            <PaymentRequestTable
              rows={paymentRequest}
              page={page}
              total={total}
              count={count}
              onPageChange={setPage}
              onShowHistory={(data) => {
                setShowHistoryAdvance(data.id);
                setShowHistoryAdvance1(data);
              }}
              onShowAttachment={(data) => setShowAttachment(data)}
              variant="approval"
            />
          </div>
        )}
      </ResponsiveListShell>

      {loading && <LoadingWidget></LoadingWidget>}
    </>
  );
};

export default PaymentRequestApprovalListForAdvanceAndInvoice;
